import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../../../Translations/LenguageContext";
import ErrorMessage from "../../../Components/ErrorMessage";
import { TbReload } from "react-icons/tb";
import Spinner from "../../../Components/Spinner";
import ReactMarkdown from "react-markdown";
import LoaderSingleSimulation from "../../../Loaders/LoaderSingleSimulation";
import { BsOpenai } from "react-icons/bs";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const SinglePromptSimulationModal = ({
    account_id,
    org_id,
    geo_id,
    selectedSimulation,
    setSelectedSimulation,
    show,
    handleClose
}) => {
    const { t } = useLanguage()
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });

    const [openAnswer, setOpenAnswer] = useState(false)
    const [openImprovements, setOpenImprovements] = useState(false)

    const toggleAnswer = () => {
        openAnswer ? setOpenAnswer(false) : setOpenAnswer(true)
    }

    const toggleImprovements = () => {
        openImprovements ? setOpenImprovements(false) : setOpenImprovements(true)
    }

    const closeModal = () => {
        handleClose();
        setSelectedSimulation({})
        setOpenAnswer(false)
        setOpenImprovements(false)
        setLoading(false)
        setData([])
    };

    const fetchData = async () => {
        if (!show) return;
        setLoading(true);
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_single_prompt_simulation`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    geo_id,
                    simulation_id: selectedSimulation
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Failed to fetch");
            }
            setData(result.data || []);
        } catch (err) {
            console.error("Error fetching models:", err);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    useEffect(() => {
        fetchData();
    }, [show, selectedSimulation]);

    return (
        <Modal show={show} centered onHide={closeModal} className="modal_simulation">
            <div className="modal_header">
                <p className="modal_header_title">
                    {t.geo.details}
                </p>
                {(!loading && data.engine) && (
                <div
                    className="prompts_run_engine_icons fade-in"
                    style={
                        data.engine !== "chatgpt"
                            ? {
                                backgroundImage: `url('/logos/${data.engine}.png')`,
                            }
                            : undefined
                    }
                >
                    {data.engine === "chatgpt" && (
                        <span>
                            <BsOpenai />
                        </span>
                    )}
                </div>
                )}

                <button className="context_window_footer_btn" onClick={fetchData}>
                    {loading ? (
                        <Spinner loading={loading} />
                    ) : (
                        <TbReload />
                    )}
                </button>
            </div> 
            {loading ? (
                <LoaderSingleSimulation />
            ) : (
                <div className="modal_main_cont">
                    <div className="single_simulation_cont_header">
                        <div className="single_simulation_cont_header_row">
                            <div className="single_simulation_cont_header_row_cell">
                                <p className="single_simulation_cont_header_row_cell_title fade-in">{t.geo.effectiveness} <strong>{data.effectiveness_score}/10</strong></p>
                                <p className="ngle_simulation_cont_header_row_cell_desc fade-in">{data.evaluation_explanation}</p>
                            </div>
                            <div className="single_simulation_cont_header_row_cell">
                                <p className="single_simulation_cont_header_row_cell_title fade-in">{t.geo.visibility} <strong>{data.visibility}/10</strong></p>
                                <p className="ngle_simulation_cont_header_row_cell_desc fade-in">{data.visibility_desc}</p>
                            </div>
                        </div>
                        <div className="single_simulation_cont_header_row">
                            <div className="single_simulation_cont_header_row_cell">
                                <p className="single_simulation_cont_header_row_cell_title fade-in">{t.geo.sentiment} <strong>{data.sentiment}/10</strong></p>
                                <p className="ngle_simulation_cont_header_row_cell_desc fade-in">{data.sentiment_desc}</p>
                            </div>
                            <div className="single_simulation_cont_header_row_cell">
                                <p className="single_simulation_cont_header_row_cell_title fade-in">{t.geo.position} <strong>{data.position}/10</strong></p>
                                <p className="ngle_simulation_cont_header_row_cell_desc fade-in">{data.position_desc}</p>
                            </div>
                        </div>
                        <div className="single_simulation_cont_body">
                            <div className="single_simulation_cont_body_chat_cont">
                                <div className="single_simulation_cont_item">
                                    <p className="single_simulation_cont_item_title fade-in">{t.geo.prompt}</p>
                                    <div className="single_simulation_cont_item_content_cont">
                                        <div className="single_simulation_cont_item_content fade-in">
                                            {data.prompt}
                                        </div>
                                    </div>
                                </div>
                                <div className="single_simulation_cont_item">
                                    <p className="single_simulation_cont_item_title fade-in">
                                        {t.geo.engine_answer}
                                        <button
                                            className="single_simulation_cont_item_btn"
                                            onClick={toggleAnswer}
                                        >
                                            <i className={`fa-solid fa-chevron-${openAnswer ? "up" : "down"}`}></i>
                                        </button>
                                    </p>
                                    <div className="single_simulation_cont_item_content_cont">
                                        <div className={`single_simulation_cont_item_content fade-in ${openAnswer ? "single_simulation_cont_item_content_open" : "single_simulation_cont_item_content_closed"}`}>
                                            <ReactMarkdown>
                                                {data.response_text}
                                            </ReactMarkdown>
                                        </div>
                                    </div>
                                </div>
                                <div className="single_simulation_cont_item_footer fade-in">
                                    <p>{data?.citations?.length} {t.geo.citations}</p>
                                    <p>{data?.sources?.length} {t.geo.sources}</p>
                                </div>

                            </div>

                            {/* <div className="single_simulation_cont_source_citations_cont">
                                {data?.sources?.length > 0 && (
                                    <div className="single_simulation_cont_source_citations_cont_item">
                                        <p className="single_simulation_cont_source_citations_cont_item_title">{data?.sources?.length} Sources</p>
                                        <div className="single_simulation_cont_source_citations_cont_item_source_cont">
                                            {data?.sources.map((item) => (
                                                <div className="single_simulation_cont_source_citations_cont_item_source">
                                                    <a
                                                        href={item.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {item.url}
                                                    </a>
                                                </div>))}
                                        </div>
                                    </div>
                                )}

                                {data?.citations?.length > 0 && (
                                    <div className="single_simulation_cont_source_citations_cont_item">
                                        <p className="single_simulation_cont_source_citations_cont_item_title">{data?.citations?.length} Citations</p>
                                        <div className="single_simulation_cont_source_citations_cont_item_source_cont">
                                            {data?.citations.map((item) => (
                                                <div className="single_simulation_cont_source_citations_cont_item_source">
                                                    <a
                                                        href={item.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {item.url}
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                            </div> */}

                            <div className="sw_container">
                                <div className="sw_container_item">
                                    <p className="sw_container_item_title fade-in">{t.geo.strengths}</p>
                                    <div className="sw_container_item_cont">
                                        {data?.evaluation_strengths?.map((item) => (
                                            <p className="sw_container_item_cont_item fade-in">{item}</p>
                                        ))}
                                    </div>
                                </div>
                                <div className="sw_container_item">
                                    <p className="sw_container_item_title fade-in">{t.geo.weaknesses}</p>
                                    <div className="sw_container_item_cont">
                                        {data?.evaluation_weaknesses?.map((item) => (
                                            <p className="sw_container_item_cont_item fade-in">{item}</p>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="eval_improvements_cont">
                                <p className="eval_improvements_cont_title fade-in">
                                    {t.geo.improvements}
                                    <button
                                        className="single_simulation_cont_item_btn"
                                        onClick={toggleImprovements}
                                    >
                                        <i className={`fa-solid fa-chevron-${openImprovements ? "up" : "down"}`}></i>
                                    </button>
                                </p>
                                <div className={`eval_improvements_cont_cont fade-in ${openImprovements ? "eval_improvements_cont_cont_open" : "eval_improvements_cont_cont_closed"}`}>
                                    {data?.evaluation_improvements?.map((item, index) => (
                                        <p>{index + 1}. {item}</p>
                                    ))}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            )}
            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>
                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default SinglePromptSimulationModal;